import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-602cfaf2")

_pushScopeId("data-v-602cfaf2")
const _hoisted_1 = {
  class: "dialogue-info",
  ref: "dialogueInfo"
}
const _hoisted_2 = { class: "dialogue-info-wrap" }
const _hoisted_3 = { class: "dialogue-info-table mb24" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "新增", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("选择全部")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = { class: "dialogue-role flex align-items-center" }
const _hoisted_8 = { class: "ml8" }
const _hoisted_9 = { class: "row-edit" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "btn-vertical" }, "|", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = { class: "dialogue-info-footer" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("下一步")
const _hoisted_16 = { class: "dialogue-info-wrap" }
const _hoisted_17 = { class: "dialogue-info-edit mb24" }
const _hoisted_18 = { class: "dialogue-info-edit-title flex align-items-center" }
const _hoisted_19 = { class: "title-text flex1" }
const _hoisted_20 = { class: "dialogue-info-edit-content" }
const _hoisted_21 = {
  key: 0,
  class: "dialogue-roleItem flex align-items-center ml8 display-inline-block"
}
const _hoisted_22 = { class: "ml8 mr16" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "section-tag" }, "部门", -1)
const _hoisted_24 = {
  key: 0,
  class: "display-inline-block ml10"
}
const _hoisted_25 = {
  key: 0,
  class: "display-inline-block ml10"
}
const _hoisted_26 = { class: "flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("立即触发")
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "display-inline-block mr32" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("延迟触发")
const _hoisted_30 = { class: "display-inline-block vertical-align-middle" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("0.5")
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "display-inline-block ml10" }, "min后触发", -1)
const _hoisted_33 = {
  key: 0,
  class: "key-words-wrap mb24"
}
const _hoisted_34 = { class: "row-edit" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "btn-vertical" }, "|", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_38 = { class: "expanded-table" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", null, "添加影响指标", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("span", null, "添加推演选项", -1)
const _hoisted_41 = { class: "dialogue-info-footer" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("返回")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sceneDesignMainHeader = _resolveComponent("sceneDesignMainHeader")
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_avatar = _resolveComponent("a-avatar")
  const _component_dialogueTypeTag = _resolveComponent("dialogueTypeTag")
  const _component_a_table = _resolveComponent("a-table")
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_radio = _resolveComponent("a-radio")
  const _component_a_radio_group = _resolveComponent("a-radio-group")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_time_picker = _resolveComponent("a-time-picker")
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_text_area = _resolveComponent("a-text-area")
  const _component_SceneBox = _resolveComponent("SceneBox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode(_component_sceneDesignMainHeader, {
        class: "mb24",
        headerText: _ctx.props.headerText
      }, null, 8, ["headerText"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          class: "mr10",
          type: "primary",
          onClick: _ctx.dialogueInfoModule.addDialogue,
          loading: _ctx.dialogueInfoModule.loadings.list,
          disabled: _ctx.dialogueInfoModule.disableData.add
        }, {
          default: _withId(() => [
            _createVNode(_component_PlusOutlined),
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createVNode(_component_a_button, {
          class: "mr10",
          onClick: _ctx.dialogueInfoModule.selectAll,
          loading: _ctx.dialogueInfoModule.loadings.list
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick", "loading"]),
        _createVNode(_component_a_button, {
          onClick: _ctx.dialogueInfoModule.delAll,
          disabled: _ctx.dialogueInfoModule.disableData.del,
          loading: _ctx.dialogueInfoModule.loadings.list
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick", "disabled", "loading"]),
        _createVNode(_component_a_table, {
          class: "mt16",
          columns: _ctx.dialogueInfoModule.columns,
          "data-source": _ctx.dialogueInfoModule.dialogueModule.list,
          "row-selection": { selectedRowKeys: _ctx.dialogueInfoModule.chooseState.selectedRowKeys, onChange: _ctx.dialogueInfoModule.onSelectChange },
          loading: _ctx.dialogueInfoModule.loadings.list,
          rowKey: "id"
        }, {
          roleId: _withId(({ record }) => [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_a_avatar, {
                size: 24,
                src: _ctx.dialogueInfoModule.roleNameFormat(record.roleId, "img")
              }, null, 8, ["src"]),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.dialogueInfoModule.roleNameFormat(record.roleId, "name")), 1)
            ])
          ]),
          talkType: _withId(({ record }) => [
            _createVNode(_component_dialogueTypeTag, {
              "tag-type": record.talkType
            }, null, 8, ["tag-type"])
          ]),
          operation: _withId(({ record }) => [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (_ctx.dialogueInfoModule.showEdit(record))
              }, {
                default: _withId(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _hoisted_11,
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (_ctx.dialogueInfoModule.del(record.id))
              }, {
                default: _withId(() => [
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["columns", "data-source", "row-selection", "loading"])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_a_button, {
          class: "mr18",
          type: "primary",
          onClick: _ctx.dialogueInfoModule.saveStep
        }, {
          default: _withId(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          class: "next",
          ghost: "",
          onClick: _ctx.nextStep
        }, {
          default: _withId(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogueInfoModule.isShowEdit.value]
    ]),
    _withDirectives(_createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_SvgIcon, {
            class: "my-icon",
            icon: "back2",
            onClick: _ctx.dialogueInfoModule.confirmBack
          }, null, 8, ["onClick"]),
          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.dialogueInfoModule.dialogueEditItem.item.talkName), 1)
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode(_component_a_form, {
            ref: "dialogueNormal",
            model: _ctx.dialogueInfoModule.dialogueEditForm.item,
            rules: _ctx.dialogueInfoModule.formRules,
            hideRequiredMark: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "对话类型",
                name: "talkType"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_radio_group, {
                    name: "talkTypeRadioGroup",
                    value: _ctx.dialogueInfoModule.dialogueEditForm.item.talkType,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogueInfoModule.dialogueEditForm.item.talkType = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_a_radio, { value: 0 }, {
                        default: _withId(() => [
                          _createVNode(_component_dialogueTypeTag, { "tag-type": 0 })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: 1 }, {
                        default: _withId(() => [
                          _createVNode(_component_dialogueTypeTag, { "tag-type": 1 })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, {
                        value: 2,
                        disabled: ""
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_dialogueTypeTag, { "tag-type": 2 })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "对话对象",
                name: "roleId"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    class: "w320",
                    value: _ctx.dialogueInfoModule.dialogueEditForm.item.roleId,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogueInfoModule.dialogueEditForm.item.roleId = $event))
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialogueInfoModule.roleModule.roleList, (item) => {
                        return (_openBlock(), _createBlock(_Fragment, null, [
                          (item.status)
                            ? (_openBlock(), _createBlock(_component_a_select_option, {
                                key: 0,
                                value: item.id
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(item.roleName), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  (_ctx.dialogueInfoModule.dialogueEditForm.item.roleId)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _createVNode(_component_a_avatar, {
                          size: 24,
                          src: _ctx.dialogueInfoModule.roleNameFormat(_ctx.dialogueInfoModule.dialogueEditForm.item.roleId, "img")
                        }, null, 8, ["src"]),
                        _createVNode("span", _hoisted_22, _toDisplayString(_ctx.dialogueInfoModule.roleNameFormat(_ctx.dialogueInfoModule.dialogueEditForm.item.roleId, "name")), 1),
                        _hoisted_23
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "对话名称",
                name: "talkName"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    class: "w320",
                    value: _ctx.dialogueInfoModule.dialogueEditForm.item.talkName,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogueInfoModule.dialogueEditForm.item.talkName = $event)),
                    maxlength: 10,
                    width: 320
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                class: "condition-type-form-item",
                label: "对话条件"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_form, {
                    ref: "dialogueConditionType",
                    model: _ctx.dialogueInfoModule.dialogueEditForm.item,
                    rules: _ctx.dialogueInfoModule.formRules,
                    layout: "inline",
                    hideRequiredMark: ""
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_a_form_item, { name: "conditionType" }, {
                        default: _withId(() => [
                          _createVNode(_component_a_select, {
                            class: "w320",
                            value: _ctx.dialogueInfoModule.dialogueEditForm.item.conditionType,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogueInfoModule.dialogueEditForm.item.conditionType = $event)),
                            getPopupContainer: (triggerNode) => triggerNode.parentNode
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialogueInfoModule.dialogueModule.conditionTypes, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item.value
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(item.text), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _: 1
                          }, 8, ["value", "getPopupContainer"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { name: "talkCondition" }, {
                        default: _withId(() => [
                          (_ctx.dialogueInfoModule.dialogueEditForm.item.conditionType === 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                                _createVNode(_component_a_time_picker, {
                                  value: _ctx.dialogueInfoModule.dialogueEditForm.item.talkCondition,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogueInfoModule.dialogueEditForm.item.talkCondition = $event)),
                                  valueFormat: "HH:mm:ss",
                                  use12Hours: false,
                                  getPopupContainer: _ctx.triggerNode
                                }, null, 8, ["value", "getPopupContainer"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { name: "" }, {
                        default: _withId(() => [
                          (_ctx.dialogueInfoModule.dialogueEditForm.item.conditionType === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                _createVNode(_component_a_select, {
                                  class: "w150",
                                  value: _ctx.dialogueInfoModule.conditionTarget.targetId,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogueInfoModule.conditionTarget.targetId = $event))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialogueInfoModule.conditionTargetIds.value, (target) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        value: target.targetId
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(target.targetName), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 256))
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_a_select, {
                                  class: "w80",
                                  value: _ctx.dialogueInfoModule.conditionTarget.targetType,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogueInfoModule.conditionTarget.targetType = $event))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(), _createBlock(_Fragment, null, _renderList([">","<","="], (targetId) => {
                                      return _createVNode(_component_a_select_option, { value: targetId }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(targetId), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"])
                                    }), 64))
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_a_input_number, {
                                  class: "w80",
                                  value: _ctx.dialogueInfoModule.conditionTarget.targetScore,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogueInfoModule.conditionTarget.targetScore = $event)),
                                  min: 0,
                                  max: 100
                                }, null, 8, ["value"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "对话内容",
                name: "content"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_text_area, {
                    class: "w470",
                    value: _ctx.dialogueInfoModule.dialogueEditForm.item.content,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogueInfoModule.dialogueEditForm.item.content = $event)),
                    maxlength: 200,
                    "auto-size": { minRows: 3, maxRows: 3 }
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { class: "condition-type-form-item" }, {
                default: _withId(() => [
                  _createVNode(_component_a_form, {
                    ref: "dialogueTriggerTime",
                    model: _ctx.dialogueInfoModule.dialogueEditForm.item,
                    rules: _ctx.dialogueInfoModule.formRules,
                    layout: "inline",
                    hideRequiredMark: ""
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_a_form_item, { name: "triggerCondition" }, {
                        default: _withId(() => [
                          _createVNode(_component_a_radio_group, {
                            name: "triggerTimeRadioGroup",
                            value: _ctx.dialogueInfoModule.dialogueEditForm.item.triggerCondition,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogueInfoModule.dialogueEditForm.item.triggerCondition = $event)),
                            defaultValue: 0
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_26, [
                                _createVNode(_component_a_radio, { value: 0 }, {
                                  default: _withId(() => [
                                    _hoisted_27
                                  ]),
                                  _: 1
                                }),
                                _hoisted_28,
                                _createVNode(_component_a_radio, { value: 1 }, {
                                  default: _withId(() => [
                                    _hoisted_29
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      (_ctx.dialogueInfoModule.dialogueEditForm.item.triggerCondition === 1)
                        ? (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 0,
                            name: "delayedTime"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_30, [
                                _createVNode(_component_a_select, {
                                  class: "w80",
                                  value: _ctx.dialogueInfoModule.dialogueEditForm.item.delayedTime,
                                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogueInfoModule.dialogueEditForm.item.delayedTime = $event)),
                                  getPopupContainer: _ctx.triggerNode
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_a_select_option, { value: 30 }, {
                                      default: _withId(() => [
                                        _hoisted_31
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(), _createBlock(_Fragment, null, _renderList(60, (num) => {
                                      return _createVNode(_component_a_select_option, {
                                        value: num * 60
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(num), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"])
                                    }), 64))
                                  ]),
                                  _: 1
                                }, 8, ["value", "getPopupContainer"]),
                                _hoisted_32
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      (_ctx.dialogueInfoModule.showKeyWords.value)
        ? (_openBlock(), _createBlock("div", _hoisted_33, [
            _createVNode(_component_a_form, {
              ref: "dialogueKeyWords",
              model: _ctx.dialogueInfoModule.dialogueEditForm.item,
              rules: _ctx.dialogueInfoModule.formRules,
              labelCol: { span: 2 },
              wrapperCol: { span: 21 }
            }, {
              default: _withId(() => [
                _createVNode(_component_a_form_item, {
                  label: "关键词",
                  name: "keywordsArr"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_a_select, {
                      class: "key-words-select",
                      value: _ctx.dialogueInfoModule.dialogueEditForm.item.keywordsArr,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogueInfoModule.dialogueEditForm.item.keywordsArr = $event)),
                      mode: "tags",
                      showArrow: false,
                      maxTagCount: 5,
                      onChange: _ctx.dialogueInfoModule.keyWordsChange,
                      open: false
                    }, null, 8, ["value", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.dialogueInfoModule.showDeduction.value)
        ? (_openBlock(), _createBlock(_component_SceneBox, {
            key: 1,
            class: "mb24",
            titleText: "推演选项",
            titleLine: false
          }, {
            content: _withId(() => [
              _createVNode("div", null, [
                _createVNode(_component_a_table, {
                  columns: _ctx.dialogueInfoModule.deductionColumns
                }, {
                  operation: _withId(() => [
                    _createVNode("div", _hoisted_34, [
                      _createVNode(_component_a_button, { type: "link" }, {
                        default: _withId(() => [
                          _hoisted_35
                        ]),
                        _: 1
                      }),
                      _hoisted_36,
                      _createVNode(_component_a_button, { type: "link" }, {
                        default: _withId(() => [
                          _hoisted_37
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  expandedRowRender: _withId(() => [
                    _createVNode("div", _hoisted_38, [
                      _createVNode(_component_a_table, {
                        columns: _ctx.dialogueInfoModule.deductionExpandedColumns
                      }, null, 8, ["columns"]),
                      _createVNode(_component_a_button, { class: "table-add user-select-none" }, {
                        default: _withId(() => [
                          _createVNode(_component_SvgIcon, {
                            class: "mr8",
                            icon: "add"
                          }),
                          _hoisted_39
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["columns"]),
                _createVNode(_component_a_button, { class: "table-add user-select-none" }, {
                  default: _withId(() => [
                    _createVNode(_component_SvgIcon, {
                      class: "mr8",
                      icon: "add"
                    }),
                    _hoisted_40
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_41, [
        _createVNode(_component_a_button, {
          class: "mr18",
          type: "primary",
          onClick: _ctx.dialogueEditSave
        }, {
          default: _withId(() => [
            _hoisted_42
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          class: "next",
          ghost: "",
          onClick: _ctx.dialogueInfoModule.confirmBack
        }, {
          default: _withId(() => [
            _hoisted_43
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ], 512), [
      [_vShow, _ctx.dialogueInfoModule.isShowEdit.value]
    ])
  ], 512))
})